import React, { Fragment, FunctionComponent, useCallback } from "react";
import styles from "./Sidemenu.module.scss";
import SidemenuContent from "./SidemenuContent.model";

import { CLOSE_ALL_OVERLAYS } from "layout/redux/overlay.actions";
import { Helmet } from "react-helmet-async";
import Anchor from "components/Anchor/Anchor";
import combineClasses from "helpers/combine-classes";
import useCategoriesMapping from "./hooks/useCategoriesMapping";
import { useDispatch } from "react-redux";
import IconViewer from "components/IconViewer/IconViewer";

const Sidemenu: FunctionComponent<SidemenuContent> = (props) => {
    const categories: any[] = useCategoriesMapping();

    const viewClass = styles[`view_${props.view}`];

    const dispatch = useDispatch();

    const closeOverlay = useCallback(() => {
        dispatch({
            type: CLOSE_ALL_OVERLAYS
        });
    }, [dispatch]);

    return (
        <Fragment>
            {props.view === "FULL" ? <Helmet bodyAttributes={{ class: "is-locked" }} /> : null}

            <div className={combineClasses([styles.wrapper, viewClass])}>
                {categories && categories.length > 0 ? (
                    <div className={styles.menu}>
                        {props.view === "FULL" ? (
                            <button className={styles.close_button} onClick={() => closeOverlay()}>
                                <IconViewer className={styles.close_icon} name="close" />
                            </button>
                        ) : null}

                        <div className={styles.facets}>
                            <Fragment>
                                {categories?.map((mainCategory: any, index: number) => {
                                    return (
                                        <Fragment key={`m_${index}`}>
                                            {mainCategory.subCategories && mainCategory.subCategories.length > 0 ? (
                                                <Fragment>
                                                    <strong className={styles.facet_headline}>{mainCategory.category.primaryTitle}</strong>

                                                    {mainCategory.subCategories?.map((subCategory: any, subIndex: number) => {
                                                        return (
                                                            <Anchor key={`sm_${subIndex}`} className={styles.facet_link} to={subCategory.url} onClick={closeOverlay}>{subCategory.category.primaryTitle}</Anchor>
                                                        );
                                                    })}
                                                </Fragment>
                                            ) : null}
                                        </Fragment>
                                    );
                                })}
                            </Fragment>
                        </div>
                    </div>
                ) : null}
            </div>
        </Fragment>
    );
};

export default Sidemenu;